@if (telephoneNumber() && telephoneNumber() !== '') {
  @if (telephoneLabel() !== null && telephoneLabel() !== '') {
    <div class="mb-2 text-apricot-1">{{ telephoneLabel() }}:</div>
  }

  @if (!isTelephoneVisible()) {
    <div class="flex max-w-xs justify-between gap-2">
      <span class="text-grey-1">{{ maskedTelephone() }}</span>

      <a
        (click)="showTelephone()"
        [eventAction]="'visa telefonnummer'"
        [eventCategory]="'telefonnummer'"
        [eventLabel]="label()"
        [eventParams]="eventParams()"
        appGtmEvent
        appGtmGa4Event
      >
        Visa nummer
      </a>
    </div>
  } @else {
    <a href="tel:{{ telephoneNumber() }}">
      <span>{{ telephoneNumber() }}</span>
    </a>
  }
}

